const setGenerateFromDocImportStatus = (state, payload) => {
  state.generateFromDocImportStatus = payload
}

const setGenerateFromDocImportError = (state, payload) => {
  state.generateFromDocImportError = payload
}

const setDocToQuizUniqueRequestId = (state, payload) => {
  state.docToQuizUniqueRequestId = payload
}

const setDocToQuizResult = (state, payload) => {
  state.docToQuizResult = payload
}

const setDocToQuizResultModalVisible = (state, payload) => {
  state.docToQuizResultModalVisible = payload
}

export default {
  setGenerateFromDocImportStatus,
  setGenerateFromDocImportError,
  setDocToQuizUniqueRequestId,
  setDocToQuizResult,
  setDocToQuizResultModalVisible,
}
